// extracted by mini-css-extract-plugin
module.exports = {"BrandLogo":"BrandLogo_BrandLogo__3RWS4"};